import PropTypes from 'prop-types';
import React, { Component } from 'react';

import RightColumn from '../../../components/RightColumn';
import BasicCreateButton from '../../../components/buttons/BasicCreateButton';
import { ModalActions } from '../../../actions/modal.js';
import { customWalk } from '../../../components/WbsLayout/helpers.js';


// TODO: Need to fix this
const sortable = __CLIENT__ ? require('react-sortable-tree') : {};
const WBSItem = __CLIENT__ ? require('./WBSItem.js').default : () => { return <div />; };
const SortableTree = __CLIENT__ ? require('react-sortable-tree').default : () => { return <div />; };
const getNodeAtPath = __CLIENT__ ? sortable.getNodeAtPath : () => { };
const changeNodeAtPath = __CLIENT__ ? sortable.changeNodeAtPath : () => { };

export default class WBS extends Component {
  constructor(props) {
    super(props);

    const WbsRootElementId = props.elements.find(
      ele => ele.parent_id === props.rootElementId,
    ).id;

    const treeData = customWalk({
      flatData: props.elements,
      getKey: node => node.id,
      getParentKey: node => node.parent_id,
      rootKey: WbsRootElementId,
      sortableTree: true,
    });

    this.state = {
      treeData,
      WbsRootElementId,
      currentElementId: null,
    };
  }

  _setSelectedElement = node => {
    this.setState({
      currentElementId: node.id,
    });
  };

  closeRightPanel = () => {
    this.setState({
      currentElementId: null,
    });
  };


  _onChange = treeData => {
    this.setState({ treeData });
  };

  _onMoveNode = changed => {
    const { changeParentOrOrderMutation, currentProjectId } = this.props;
    const { WbsRootElementId } = this.state;
    const childPath = [...changed.path];
    changed.path.pop();

    const parentNode = getNodeAtPath({
      treeData: this.state.treeData,
      path: changed.path,
      getNodeKey: ({ treeIndex }) => treeIndex,
      // getNodeKey: this.props.getNodeKey,
      ignoreCollapsed: false,
    });

    const newParentId = parentNode.node.id || WbsRootElementId;

    // TODO: Explicit check for a bug nick ran into where he managed to set a WBS element to be its own parent - need to explore
    // if (changed.node.id !== newParentId) {
    const updatedTreeDataWithNewParent = changeNodeAtPath({
      treeData: this.state.treeData,
      path: childPath,
      newNode: thing => {
        const temp = thing.node;
        temp.parent_id = parentNode.node.id;
        return temp;
      },
      getNodeKey: ({ treeIndex }) => treeIndex,
      ignoreCollapsed: true,
    });

    const newOrder = parentNode.node.children.findIndex(a => {
      return a.id === changed.node.id;
    });

    changeParentOrOrderMutation(
      changed.node.id,
      newParentId,
      newOrder,
      currentProjectId,
    );

    this.setState({
      treeData: updatedTreeDataWithNewParent
    });
    // }

  };

  determineRightSidebar = currentElementId => {
    if (currentElementId) {
      const entity = currentElementId;
      const callback = this.closeRightPanel;
      const entityType = 'wbs';

      return (
        <RightColumn
          entity={entity}
          entityType={entityType}
          callback={callback}
          flexOverride
        />
      );
    }

    return <div />;
  };

  componentWillUpdate(nextProps, nextState) {
    if (this.props.elements !== nextProps.elements) {
      const treeData = customWalk({
        flatData: nextProps.elements,
        getKey: node => node.id,
        getParentKey: node => node.parent_id,
        rootKey: nextState.WbsRootElementId,
        sortableTree: true,
      });

      this.setState({
        treeData,
      });
    }
  }

  handleClickNewWbs = () => {
    const { wbsTypeId, dispatch } = this.props;

    dispatch(ModalActions.toggleModal({
      name: 'CreateElementNewModal',
      options: {
        elementTypeId: wbsTypeId,
      },
    }));
  }

  render() {
    const { treeData, currentElementId } = this.state;

    const mainWbsContent = treeData.length === 0 ? (
        <div>Create a Work Breakdown Structure element to begin.</div>
      ) : (
        <SortableTree
          treeData={treeData}
          onChange={changedTreeData => this._onChange(changedTreeData)}
          onMoveNode={changed => this._onMoveNode(changed)}
          nodeContentRenderer={WBSItem}
          rowHeight={40}
          generateNodeProps={({ node }) => ({
            setSelectedElement: () => {
              this._setSelectedElement(node);
            },
          })}
        />
      )

    return (
      <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
        <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
          <h2>
            <span>Work Breakdown Structure</span>
          </h2>
          <BasicCreateButton
            className="btn btn-primary btn-sm"
            onClick={this.handleClickNewWbs}
            style={{ padding: '0.25rem 0.5rem', width: 150 }}
          >
            <i className="fa fa-plus"></i>
            <span> New WBS Element</span>
          </BasicCreateButton>
          {mainWbsContent}
        </div>
        {this.determineRightSidebar(currentElementId)}
      </div>
    );
  }
}

WBS.propTypes = {
  rootElementId: PropTypes.string,
  changeParentOrOrderMutation: PropTypes.func,
  elements: PropTypes.array,
  currentProjectId: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/views/Project/WBS/WBS.js